import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Headphones } from "lucide-react";

export function Logo({ light = false }) {
  return (
    <span className={`font-display text-2xl font-semibold tracking-tight ${light ? "text-white" : "text-[#0a2540]"}`}>
      Interpret<span className="text-teal-500">a</span>
      <span className="inline-block h-1.5 w-1.5 rounded-full bg-yellow-400 ml-1 align-middle" />
    </span>
  );
}

export default function MarketingHeader() {
  const links = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Our Services" },
    { to: "/news", label: "News" },
    { to: "/contact", label: "Contact Us" },
  ];
  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" data-testid="brand-link"><Logo /></Link>
        <nav className="hidden md:flex items-center gap-7 text-sm font-medium">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                isActive ? "text-[#0a2540] border-b-2 border-teal-500 pb-0.5" : "text-slate-500 hover:text-[#0a2540] transition-colors"
              }
            >
              {l.label}
            </NavLink>
          ))}
          <NavLink
            to="/interpreter-login"
            data-testid="nav-interpreter-login"
            className={({ isActive }) =>
              `flex items-center gap-1.5 ${isActive ? "text-[#0a2540]" : "text-slate-500 hover:text-[#0a2540]"} transition-colors`
            }
          >
            <Headphones className="h-4 w-4" /> Interpreter Login
          </NavLink>
          <Link to="/contact">
            <Button
              data-testid="nav-quote-btn"
              className="rounded-full bg-yellow-400 text-[#0a2540] hover:bg-yellow-300 font-semibold"
            >
              Get a Quote
            </Button>
          </Link>
        </nav>
        <Link to="/contact" className="md:hidden">
          <Button size="sm" data-testid="nav-quote-btn-mobile"
            className="rounded-full bg-yellow-400 text-[#0a2540] hover:bg-yellow-300 font-semibold">
            Get a Quote
          </Button>
        </Link>
      </div>
    </header>
  );
}
